import type { AuthStore } from './types';
import reducer from './reducer';
import sagas from './sagas';

const authStore = {
  reducer,
  sagas,
};

export type { AuthStore };
export default authStore;
